export enum OfferPriceType {
  Percents = "Per",
  Absolute = "Abs",
  Custom = "Cus",
}
